import {
  handleAvailable,
  handleRequest,
  handleUnavailable,
} from '../reducerHandlers';
import {
  LAYOUT_IDS_AVAILABLE,
  LAYOUT_IDS_REQUEST,
  LAYOUT_IDS_UNAVAILABLE,
  SNACK_ALERT_SET,
} from './constants';
import { createReducer } from './utils';

const defaultState = {
  layoutIds: [],
  isLoadingLayoutIds: false,
  layoutIdsRequestId: null,
};

export const reducer = createReducer(defaultState, {
  [LAYOUT_IDS_REQUEST]: handleRequest,
  [LAYOUT_IDS_AVAILABLE]: handleAvailable,
  [LAYOUT_IDS_UNAVAILABLE]: handleUnavailable,
});

export function getLayoutIds(payload) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    const keyState = 'layoutIds';
    const loadingName = 'isLoadingLayoutIds';
    // Only the latest request may write its result, so a slower response for a
    // previous session or AI type cannot overwrite the current options.
    const requestId = Date.now().toString(36) + Math.random().toString(36);
    const isStale = () => getState().layoutIds.layoutIdsRequestId !== requestId;
    dispatch({
      type: LAYOUT_IDS_REQUEST,
      payload: {
        loadingName: loadingName,
        aditionalStates: { layoutIdsRequestId: requestId },
      },
    });
    try {
      const response = await dataSource.getLayoutIds(payload);
      if (isStale()) return;
      dispatch({
        type: LAYOUT_IDS_AVAILABLE,
        payload: {
          keyState: keyState,
          data: response?.layout_ids,
          loadingName: loadingName,
        },
      });
    } catch (error) {
      console.error('error: ', error);
      if (isStale()) return;
      dispatch({
        type: LAYOUT_IDS_UNAVAILABLE,
        payload: {
          keyState: keyState,
          loadingName: loadingName,
          defaultState: [],
        },
      });
      const snackAlert = {
        open: true,
        message: 'There was an error getting the layout ids. Please try again.',
        severity: 'error',
      };
      dispatch({ type: SNACK_ALERT_SET, payload: { snackAlert } });
    }
  };
}
